import Axios from 'axios';

const odsURL = 'https://ods8.s3-eu-west-1.amazonaws.com/acouch8.json';
let ods;

export default {
  moveDrawToBoard(draw, board, drawIndex, toSquare) {
    const droppedTile = { ...draw[drawIndex] };
    const resultBoard = { ...board };
    let resultDraw = draw.slice();
    const targetSquare = { ...toSquare };
    if (typeof targetSquare.droppedTile === 'undefined') {
      targetSquare.droppedTile = droppedTile;
      targetSquare.justDropped = true;
      resultDraw.splice(drawIndex, 1);
    } else if (targetSquare.justDropped) {
      const switchedTile = targetSquare.droppedTile;
      targetSquare.droppedTile = droppedTile;
      resultDraw.splice(drawIndex, 1, switchedTile);
    }
    resultDraw = resultDraw.map((tile, index) => {
      const result = { ...tile };
      result.drawIndex = index;
      return result;
    });
    resultBoard.squares[targetSquare.row][targetSquare.column] = targetSquare;
    return {
      board: resultBoard,
      draw: resultDraw,
    };
  },
  moveBoardToBoard(board, fromSquare, toSquare) {
    const resultBoard = { ...board };
    const targetSquare = { ...toSquare };
    const originSquare = { ...fromSquare };
    if (typeof targetSquare.droppedTile === 'undefined') {
      targetSquare.droppedTile = originSquare.droppedTile;
      targetSquare.justDropped = true;
      delete originSquare.droppedTile;
      originSquare.justDropped = false;
    } else if (targetSquare.justDropped) {
      const originDroppedTile = originSquare.droppedTile;
      originSquare.droppedTile = targetSquare.droppedTile;
      targetSquare.droppedTile = originDroppedTile;
    }
    resultBoard.squares[targetSquare.row][targetSquare.column] = targetSquare;
    resultBoard.squares[originSquare.row][originSquare.column] = originSquare;
    return {
      board: resultBoard,
    };
  },
  moveBoardToDraw(board, draw, drawDropIndex, fromSquare) {
    const resultBoard = { ...board };
    let resultDraw = draw.slice();
    const originSquare = { ...fromSquare };
    resultDraw.splice(drawDropIndex, 0, originSquare.droppedTile);
    delete originSquare.droppedTile;
    originSquare.justDropped = false;
    resultBoard.squares[originSquare.row][originSquare.column] = originSquare;
    resultDraw = resultDraw.map((t, index) => {
      const result = { ...t };
      result.drawIndex = index;
      return result;
    });
    return {
      board: resultBoard,
      draw: resultDraw,
    };
  },
  moveDrawToDraw(draw, tile, drawIndex, drawDropIndex) {
    let resultDraw = draw.slice();
    if (drawDropIndex >= resultDraw.length) {
      resultDraw[resultDraw.length] = tile;
      resultDraw.splice(drawIndex, 1);
    } else {
      let dropIndex = drawDropIndex;
      if (drawDropIndex > drawIndex) {
        dropIndex = drawDropIndex - 1;
      }
      resultDraw.splice(drawIndex, 1);
      resultDraw.splice(dropIndex, 0, tile);
    }
    resultDraw = resultDraw.map((t, index) => {
      const result = { ...t };
      result.drawIndex = index;
      return result;
    });
    return {
      draw: resultDraw,
    };
  },
  clearBoard(draw, board) {
    const resultBoard = { ...board };
    let resultDraw = draw.slice();
    const squares = board.squares.reduce((acc, el) => acc.concat(el), []);
    squares.filter(square => square.justDropped)
      .forEach((square) => {
        resultDraw.push(square.droppedTile);
        const originSquare = { ...square };
        delete originSquare.droppedTile;
        originSquare.justDropped = false;
        resultBoard.squares[originSquare.row][originSquare.column] = originSquare;
      });
    resultDraw = resultDraw.map((t, index) => ({
      ...t,
      drawIndex: index,
      value: t.tile.value === '?' ? '?' : t.value,
    }));
    return {
      board: resultBoard,
      draw: resultDraw,
    };
  },
  moveWordToBoard(draw, board, wordReference) {
    let resultBoard = { ...board };
    let resultDraw = draw.slice();
    const re = /^([0-9]|1[0-5])([A-O])\s([\w()]+)$|^([A-O])([0-9]|1[0-5])\s([\w()]+)$/g;
    if (wordReference.toUpperCase().match(re)) {
      ({ board: resultBoard, draw: resultDraw } = this.clearBoard(draw, board));
      const match = re.exec(wordReference);
      const horizontal = !match[1];
      const firstRow = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(horizontal ? match[4] : match[2]);
      const firstColumn = horizontal ? match[5] - 1 : match[1] - 1;
      const word = horizontal ? match[6] : match[3];
      let joker = false;
      let letterIndex = 0;
      [...word].forEach((letter) => {
        if (letter !== '(' && letter !== ')') {
          if (joker) {
            const dt = resultDraw.find(
              droppedTile => droppedTile.tile.point === 0
              && droppedTile.value === letter)
              || resultDraw.find(droppedTile => droppedTile.tile.point === 0);
            if (dt) {
              dt.value = letter;
            } else {
              return;
            }
          }
          const col = horizontal ? firstColumn + letterIndex : firstColumn;
          const row = horizontal ? firstRow : firstRow + letterIndex;
          const res = this.moveLetterToBoard(resultBoard, resultDraw, letter, row, col);
          resultBoard = res.board;
          resultDraw = res.draw;
          letterIndex += 1;
        }
        joker = letter === '(';
      });
    }
    return {
      board: resultBoard,
      draw: resultDraw,
    };
  },
  moveLetterToBoard(board, draw, letter, row, column) {
    if (board.squares[row] && board.squares[row][column]) {
      const square = board.squares[row][column];
      if (!square.droppedTile || square.droppedTile.justDropped) {
        const drawIndex = draw.findIndex(tile => tile.value === letter);
        if (drawIndex >= 0) {
          return this.moveDrawToBoard(draw, board, drawIndex, board.squares[row][column]);
        }
        const jokerIndex = draw.findIndex(droppedTile => droppedTile.tile.point === 0);
        if (jokerIndex >= 0) {
          const resultDraw = draw.slice();
          resultDraw[jokerIndex].value = letter;
          return this.moveDrawToBoard(resultDraw, board, jokerIndex, board.squares[row][column]);
        }
      }
    }
    return {
      board,
      draw,
    };
  },
  isBoardValid(board) {
    const droppedSquares = board.squares
      .reduce((acc, el) => acc.concat(el), [])
      .filter(square => square.justDropped);
    if (droppedSquares.length === 0) {
      return {
        valid: false,
        error: '',
      };
    }
    const uniqueRows = new Set(droppedSquares.map(square => square.row));
    const uniqueColumns = new Set(droppedSquares.map(square => square.column));
    if (uniqueRows.size > 1 && uniqueColumns.size > 1) {
      return {
        valid: false,
        error: 'Les lettres ne sont pas sur la même ligne ou la même colonne.',
      };
    }
    const attached = droppedSquares.reduce(
      (acc, square) => acc || this.isAttachedToGame(board, square.row, square.column), false);
    if (!attached) {
      return {
        valid: false,
        error: 'Aucune lettre rattachée au reste du jeu.',
      };
    }
    const attachedEachOther = this.isNoBlankSquare(board,
      droppedSquares[0], droppedSquares[droppedSquares.length - 1]);
    if (!attachedEachOther) {
      return {
        valid: false,
        error: 'Des lettres ne sont pas rattachées au reste du jeu.',
      };
    }
    if (droppedSquares.find(square => square.droppedTile.value === '?')) {
      return {
        valid: false,
        error: 'Cliquez sur le joker pour le remplacer.',
      };
    }
    return {
      valid: true,
      result: this.calculateWords(board),
    };
  },
  isAttachedToGame(board, row, column) {
    return (row === 7 && column === 7) ||
      (row > 0 && this.isExistsTile(board.squares[row - 1][column])) ||
      (row < board.squares.length - 1 && this.isExistsTile(board.squares[row + 1][column])) ||
      (column > 0 && this.isExistsTile(board.squares[row][column - 1])) ||
      (column < board.squares[row].length - 1 && this.isExistsTile(board.squares[row][column + 1]));
  },
  isExistsTile(square) {
    return square.droppedTile && !square.justDropped;
  },
  isNoBlankSquare(board, fromSquare, toSquare) {
    if (fromSquare.row === toSquare.row && fromSquare.column === toSquare.column) {
      return true;
    } else if (!fromSquare.droppedTile) {
      return false;
    } else if (fromSquare.row === toSquare.row) {
      return this.isNoBlankSquare(board,
        board.squares[fromSquare.row][fromSquare.column + 1], toSquare);
    }
    return this.isNoBlankSquare(board,
      board.squares[fromSquare.row + 1][fromSquare.column], toSquare);
  },
  findHorizontalSquaresForWord(squares, row, column) {
    return squares
      .filter(square => square.row === row && square.droppedTile)
      .reduce((acc, square) => {
        if (acc.length === 0
          || acc[acc.length - 1].column === square.column - 1) {
          return acc.concat(square);
        } else if (acc[acc.length - 1].column < column) {
          return [square];
        }
        return acc;
      }, []);
  },
  squaresToWordReference(squares) {
    const word = squares.reduce((acc, square) => {
      if (square.droppedTile.tile.value === '?') {
        return `${acc}(${square.droppedTile.value})`;
      }
      return acc + square.droppedTile.value;
    }, '');
    const uniqueRows = new Set(squares.map(square => square.row));
    const horizontal = uniqueRows.size === 1;
    if (horizontal) {
      const reference = `${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(squares[0].row)}${squares[0].column + 1}`;
      return `${reference} ${word}`;
    }
    const reference = `${squares[0].column + 1}${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(squares[0].row)}`;
    return `${reference} ${word}`;
  },
  async loadOds() {
    return Axios.get(odsURL)
      .then((response) => {
        ods = response.data;
      });
  },
  isWordInOds(word) {
    return ods.indexOf(word.toUpperCase()) >= 0;
  },
  transpose(squares) {
    return squares.map(square => ({
      ...square,
      row: square.column,
      column: square.row,
    }));
  },

  countWordPoint(squares) {
    const multiplicator = squares.filter(square => square.justDropped && (square.squareType === 'tripleWord' || square.squareType === 'doubleWord'))
      .reduce((acc, square) => (square.squareType === 'tripleWord' ? acc * 3 : acc * 2), 1);

    const sum = squares.reduce((acc, square) => {
      if (square.squareType === 'doubleLetter' && square.justDropped) {
        return acc + (2 * square.droppedTile.tile.point);
      }
      if (square.squareType === 'tripleLetter' && square.justDropped) {
        return acc + (3 * square.droppedTile.tile.point);
      }
      return acc + square.droppedTile.tile.point;
    }, 0);

    const bonus = squares.filter(square => square.justDropped).length === 7 ? 50 : 0;
    return (multiplicator * sum) + bonus;
  },

  calculateWords(board) {
    const words = [];
    const squares = board.squares.reduce((acc, el) => acc.concat(el), []);
    const droppedSquares = board.squares.reduce((acc, el) => acc.concat(el), [])
      .filter(square => square.justDropped);
    if (droppedSquares.length === 0) {
      return {
        total: 0,
        valid: false,
        words: [],
      };
    }
    const uniqueRows = new Set(droppedSquares.map(square => square.row));
    const horizontal = uniqueRows.size === 1 && squares.filter(square =>
      square.droppedTile &&
      square.row === droppedSquares[0].row && (square.column === droppedSquares[0].column + 1
        || square.column === droppedSquares[0].column - 1))
      .length > 0;

    {
      const row = droppedSquares[0].row;
      const column = droppedSquares[0].column;
      const mainWord = horizontal
        ? this.findHorizontalSquaresForWord(squares, row, column)
        : this.transpose(this.findHorizontalSquaresForWord(this.transpose(squares), column, row));
      const valid = this.isWordInOds(mainWord.reduce((acc, square) => acc + square.droppedTile.value, ''));
      words.push({
        reference: this.squaresToWordReference(mainWord),
        valid,
        points: valid
          ? this.countWordPoint(mainWord)
          : 0,
      });
    }

    droppedSquares.forEach((droppedSquare) => {
      const row = droppedSquare.row;
      const column = droppedSquare.column;
      const word = horizontal
        ? this.transpose(this.findHorizontalSquaresForWord(this.transpose(squares), column, row))
        : this.findHorizontalSquaresForWord(squares, row, column);
      if (word.length > 1) {
        const valid = this.isWordInOds(word.reduce((acc, square) => acc + square.droppedTile.value, ''));
        words.push({
          reference: this.squaresToWordReference(word),
          valid,
          points: valid ? this.countWordPoint(word) : 0,
        });
      }
    });

    const valid = words.reduce((acc, word) => acc && word.valid, true);
    return {
      total: valid ? words.reduce((acc, word) => acc + word.points, 0) : 0,
      valid,
      words,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/games/board-game-service.js